import { render, staticRenderFns } from "./CustomerRatings.vue?vue&type=template&id=1a8a7411&scoped=true"
import script from "./CustomerRatings.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRatings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomerRatings.vue?vue&type=style&index=0&id=1a8a7411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a7411",
  null
  
)

export default component.exports